export const nativeExtensionsListWithSettings = [
    'photoCapture',
    'teleconsent',
    'payments',
];
